export default {"src":"/_next/static/media/notarizetion_icon.541d21d4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};